import { ReactNode, ReactElement } from 'react'
import { Menu as HeadlessMenu } from '@headlessui/react'

import { Items } from './Items'
import { Item } from './Item'
import { ItemHeader } from './ItemHeader'
import { ItemDivider } from './ItemDivider'
import { Button } from './Button'

type MenuProps = {
    children: ReactNode | ((props: { open: boolean; close: () => void }) => ReactElement<any, string>)
    [x: string]: any
}

export const Menu = ({ children, ...props }: MenuProps) => {
    return <HeadlessMenu {...props}>{children}</HeadlessMenu>
}

Menu.Button = Button
Menu.Items = Items
Menu.Item = Item
Menu.ItemDivider = ItemDivider
Menu.ItemHeader = ItemHeader
